import type { ThemeTreeType } from 'types/index.d';


export const isThemeTreeType = (obj: any): obj is ThemeTreeType => {
  if (obj['style']) return true;
  return false;
};
